define('app/components/dashboard/dashboardController.js',[], function() {
	function dashboardController($scope, $routeParams) {
		if ( !app ) {
			app = getQlikApp();
			gapp = app;
		}

		app.clearAll();
		

		//Get data for #race-section
		app.createGenericObject({
			year: {
				qStringExpression: '=Max(year)'
			}, 
			latestRaceName: {
				qStringExpression: '=FirstSortedValue(DISTINCT [races.name], -[resultId])'
			}, 
			latestRaceCity: {
				qStringExpression: '=FirstSortedValue(DISTINCT [location], -[resultId])'
			}, 
			latestRaceDate: {
				qStringExpression: '=FirstSortedValue(DISTINCT Date([date]), -[resultId])'
			}, 
			latestWinnerName: {
				qStringExpression: '=FirstSortedValue( {1<raceId = {"$(=FirstSortedValue(DISTINCT [raceId], -[resultId]  ))"} >} distinct drivername, resultId)'
			}, 
			latestWinnerTime: {
				qStringExpression: 'FirstSortedValue( {1<raceId = {"$(=FirstSortedValue(DISTINCT [raceId], -[resultId]  ))"} >} distinct [results.time], resultId)'
			}
		}, function(reply) {
			$scope.year = reply.year;
			console.log(reply.year);
			$scope.latestRaceName = reply.latestRaceName;
			$scope.latestRaceCity = reply.latestRaceCity;
			$scope.latestRaceDate = reply.latestRaceDate;
			$scope.latestWinnerName = reply.latestWinnerName;
			$scope.latestWinnerTime = reply.latestWinnerTime;
		});

		//Get data for #standings-section
		app.createCube({
			qDimensions: [{
				qDef: {
					qFieldDefs: ['drivername']
				}
			}],
			qMeasures: [{
				qDef: {
					qDef: 'Sum({<year={"$(=Max(year))"}>} results.points)'
				},
				qSortBy: {
					qSortByNumeric: -1,
              	}
			}, {
				qDef: {
					qDef: 'Count( {$<year={"$(=Max(year))"},[results.position]={1}>} [results.position])'
				}
			},{
				qDef: {
					qDef: 'Only({<year={"$(=Max(year))"}>} constructors.name)'
				}
			}, {
				qDef: {
					qDef: 'Only({<year={"$(=Max(year))"}>} drivers.nationality)'
				}
			}],
			qInitialDataFetch: [{
				qHeight: 500,
				qWidth: 5
			}],
			qInterColumnSortOrder: [1, 2, 0, 3, 4]
		}, function(reply) {
			var qMatrix = reply.qHyperCube.qDataPages[0].qMatrix;
			var standings = [];
			qMatrix.forEach(function(driver, i) {
				if(driver[0].qText !== "-" && driver[1].qText !== "-" && driver[2].qText !== "-" && driver[3].qText !== "-" && driver[4].qText !== "-") {
					var data = {
						position: i+1,
						name: driver[0].qText,
						points: driver[1].qText,
						wins: driver[2].qText,
						construc: driver[3].qText,
						country: driver[4].qText
					};
				standings.push(data);
				}
			});
			$scope.driverStandings = standings;
		});

		app.createCube({
			qDimensions: [{
				qDef: {
					qFieldDefs: ['[constructors.name]']
				}
			}],
			qMeasures: [{
				qDef: {
					qDef: 'Sum({<year={"$(=Max(year))"}>} [constructorresults.points])'
				},
				qSortBy: {
					qSortByNumeric: -1,
              	}
			}, {
				qDef: {
					qDef: 'Count( {$<year={"$(=Max(year))"},[results.position]={1}>} [results.position])'
				}
			}, {
				qDef: {
					qDef: "concat({<year={'$(=Max(year))'}>} [drivername], '<br>')"
				}
			}, {
				qDef: {
					qDef: 'Only({<year={"$(=Max(year))"}>} [constructors.nationality])'
				}
			}],
			qInitialDataFetch: [{
				qHeight: 500,
				qWidth: 5
			}],
			qInterColumnSortOrder: [1, 0, 2]
		}, function(reply) {
			var qMatrix = reply.qHyperCube.qDataPages[0].qMatrix;
			var standings = [];
			qMatrix.forEach(function(construct, i) {
				var data = {
					position: i+1,
					name: construct[0].qText,
					points: construct[1].qText,
					wins: construct[2].qText,
					drivers: construct[3].qText,
					country: construct[4].qText
				};
				standings.push(data);
			});
			$scope.constructorStandings = standings;
		});

	}

  	dashboardController.$inject=['$scope','$routeParams'];

  	return dashboardController;
});
